module.exports = __webpack_public_path__ + "static/slider-img-2-2c5bd89ac2d68b57aca213530105530d.jpg";